import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalSejaProComponent } from './modal-seja-pro.component';
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';


@NgModule({
  declarations: [
    ModalSejaProComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule.pick(TablerIcons),
  ]
})
export class ModalSejaProModule { }
